import {
	formatDate,
	formatCapitalize,
	formatActeur,
	formatChambre,
	formatCell,
	formatRow,
} from "../formatters";
import { QuestionIcon } from "@logora/parliament.icons.regular_icons";
import { Label } from "@logora/parliament.ui.label";

export const formatType = (item) => {
	let type = "Question au gouvernement";
	if (item.type === "QE") {
		type = "Question écrite";
	} else if (item.type === "QOSD") {
		type = "Question orale sans débat";
	} else if (item.type === "QG") {
		type = "Question au gouvernement";
	}
	return <Label text={type} />;
};

export const formatCodeCloture = (item) => {
	let codeCloture = null;
	if (item.codeCloture === "REP_PUB") {
		codeCloture = "Réponse reçue";
	} else if (item.codeCloture === "DE") {
		codeCloture = "Déposée";
	} else if (item.codeCloture === "AU") {
		codeCloture = "Retirée";
	} else if (item.codeCloture === "FM") {
		codeCloture = "Caduque";
	} else if (item.codeCloture === "ID") {
		codeCloture = "Transformée";
	} else if (item.codeCloture === "ANSE") {
		codeCloture = "Transformée";
	}

	if (!codeCloture) return null;

	const colorVariants = {
		success: "Réponse reçue",
		info: ["Déposée", "Transformée"],
		cancel: ["Caduque", "Retirée"],
	};
	return (
		<Label
			text={codeCloture}
			variantsObject={colorVariants}
			colorType={codeCloture}
		/>
	);
};

const columns = [
	{
		header: "Chambre",
		accessorKey: "chambre",
		cell: (info) => formatChambre(formatCell(info)),
		enableSorting: false,
		meta: {
			filter: {
				label: "Chambre",
				variant: "select",
				options: [
					{ value: null, label: "Tous" },
					{
						value: "AN",
						label: "AN",
					},
					{
						value: "SN",
						label: "SN",
					},
				],
			},
		},
	},
	{
		header: "Date",
		accessorKey: "dateDepot",
		cell: (info) => formatDate(formatCell(info)),
		defaultSorting: "desc",
		meta: {
			filter: {
				label: "Date de dépôt",
				variant: "date-range",
				labels: ["Après le", "Avant le"],
			},
		},
	},
	{
		header: "Type",
		accessorKey: "type",
		cell: (info) => formatType(formatRow(info)),
		enableSorting: false,
		meta: {
			filter: {
				label: "Type",
				variant: "select",
				options: [
					{ value: null, label: "Tous" },
					{ value: "QG", label: "Question au gouvernement" },
					{ value: "QOSD", label: "Question orale sans débat" },
					{ value: "QE", label: "Question écrite" },
				],
			},
		},
	},
	{
		header: "Auteur",
		accessorKey: "acteurRef",
		cell: (info) => formatActeur(formatCell(info)),
		enableSorting: false,
	},
	{ header: "Titre", accessorKey: "titre", enableSorting: false },
	{
		header: "Catégorie",
		accessorKey: "rubrique",
		cell: (info) => formatCapitalize(formatCell(info)),
		enableSorting: false,
	},
	{
		header: "Ministère destinataire",
		accessorKey: "minIntRef.libelleAbrege",
		enableSorting: false,
	},
	{
		header: "Statut",
		accessorKey: "codeCloture",
		cell: (info) => formatCodeCloture(formatRow(info)),
		enableSorting: false,
		meta: {
			filter: {
				label: "Statut",
				variant: "select",
				options: [
					{ value: null, label: "Tous" },
					{ value: "DE", label: "Déposée" },
					{ value: "REP_PUB", label: "Réponse reçue" },
					{ value: "AU", label: "Retirée" },
					{ value: "FM", label: "Caduque" },
					{ value: "ID", label: "Transformée" },
				],
			},
		},
	},
];

export const questionDataset = {
	key: "questions",
	name: "Questions",
	columns: columns,
	filterMapping: { organeRefUid: "acteurRef_groupeParlementaireUid" },
	include: ["acteurRef.groupeParlementaire", "acteurRef.mandatPrincipal", "minIntRef"],
	searchPlaceholder: "Rechercher une question...",
	icon: <QuestionIcon width={20} height={20} />,
};
